<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center style="background-color: #f6fff9">
              <v-flex xs12>
                <v-card min-height="100vh" color="#FFFFFF" flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";

export default {
  name: "DistrictMedicalOfficerLayout",
  components: {
    AppHeader,
    AppSidebar,
  },
  data() {
    return {
      // open state for the sidebar; only used below md, where it overlays
      sideNav: false,
      items: [
        {
          title: "Snake Bite Insights",
          icon: "mdi-chart-timeline-variant",
          path: "/districtMedical",
        },
        {
          title: "Snake Bite Alerts",
          icon: "mdi-bell-alert",
          path: "/districtMedical/snakebiteAlerts",
        },
        {
          title: "Anti-Venom Stock",
          icon: "mdi-medical-bag",
          path: "/districtMedical/stockVenom",
        },
        {
          title: "Hospitals Network",
          icon: "mdi-hospital-building",
          path: "/districtMedical/hospitals",
        },
        // {
        //   title: "Rescuer List",
        //   icon: "mdi-account-multiple-plus",
        //   path: "/districtMedical/rescuerList",
        // },
        // {
        //   title: "Snake Reports",
        //   icon: "mdi-file-document-outline",
        //   path: "/districtMedical/snakereports",
        // },
        // {
        //   title: "Identification Help",
        //   icon: "mdi-help-circle-outline",
        //   path: "/districtMedical/identificationHelp",
        // },
        // {
        //   title: "Activity Log",
        //   icon: "mdi-history",
        //   path: "/districtMedical/activityLog",
        // },
        // {
        //   title: "Control Room Directory",
        //   icon: "mdi-phone-in-talk",
        //   path: "/districtMedical/controlRoomList",
        // },
      ],
      right: null,
    };
  },
};
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>
